import { createContext, useEffect, useRef } from "react";
import { API_ROOT_URL } from "../config";
import { API } from "./api";

export const APIContext = createContext<API>(null as any);

interface APIProviderProps {
  children: any;
}

export const APIProvider = ({ children }: APIProviderProps) => {
  const apiRef = useRef(new API(API_ROOT_URL));
  useEffect(() => {
    apiRef.current.validateToken();
  }, []);
  return (
    <APIContext.Provider value={apiRef.current}>{children}</APIContext.Provider>
  );
};
